module.exports = __webpack_public_path__ + "static/media/YF64_4.5fedf8fc.jpg";